import logo from './Media/dual_logo_white.png';
import './main.css';
import './custom.css';
import Form from "./Form";
import 'react-bootstrap-typeahead/css/Typeahead.css';


function App() {
  const date = `${new Date().getFullYear()}`;
  return (
      <div className = "root">
        <header>
          <div className = "header-container">
            <div className = "container">
              <div className="row">
                <div className="width-third">
                  <img src={logo} className="App-logo" alt="logo" />
                </div>
                <div className="width-third"></div>
                <div className="width-third">
                  <span className="header-text">If you require any help with this form please contact DUAL Compliance at <a href="mailto:compliance@dualgroup.com">compliance@dualgroup.com</a></span>
                </div>
              </div>
           </div>
          </div>
        </header>
        
        <div className="main-container">
          <div className="container round">
            <body>
              <Form />
            </body>
          </div>
        </div>
        <footer>
          <div className = "header-container">
            <div className = "container">
            <span className="footer">© Copyright {date} DUAL | All Rights Reserved | <a href="https://www.dualgroup.com/privacy-and-data-protection-policy" target="_blank">Privacy Policy</a> | <a href="https://www.dualgroup.com/cookies" target="_blank">Cookie Policy</a></span>
            </div>
          </div>
        </footer>
      </div>
);
}

export default App;
